const roundPercentage = (value) => {
  if (!Number.isFinite(value)) return 0;
  return Math.round(value * 10) / 10;
};

export const getOrderItemsForPicking = (order) => {
  return order?.all_order_items || order?.order_items || [];
};

export const getOrderPickingMetrics = (order) => {
  const allItems = getOrderItemsForPicking(order);

  if (allItems.length === 0) {
    return {
      totalQuantity: 0,
      pendingQuantity: 0,
      preparedQuantity: 0,
      servedQuantity: 0,
      servableQuantity: 0,
      servablePercentage: 0,
      preparationPercentage: 0,
      servedPercentage: 0,
      orderFilterState: "pending",
      derivedStatusText: "Sin líneas",
      derivedStatusTone: "bg-slate-100 text-slate-700",
    };
  }

  const totalQuantity = allItems.reduce((sum, item) => sum + (item.quantity || 0), 0);
  const pendingQuantity = allItems.reduce((sum, item) => sum + (item.pending_quantity || 0), 0);
  const preparedQuantity = allItems.reduce((sum, item) => sum + (item.preparation_quantity || 0), 0);
  const servedQuantity = allItems.reduce((sum, item) => sum + (item.delivered_quantity || 0), 0);

  const servableQuantity = allItems.reduce((sum, item) => {
    const pending = item.pending_quantity || 0;
    if (pending <= 0) return sum;

    const inventoryItem = item.product?.inventory?.find(
      (inv) => inv.size === item.size && inv.color === item.color
    );
    const stockAvailable = inventoryItem?.quantity || 0;
    return sum + Math.min(stockAvailable, pending);
  }, 0);

  const servablePercentage = pendingQuantity > 0 ? roundPercentage((servableQuantity / pendingQuantity) * 100) : 0;
  const preparationPercentage = totalQuantity > 0 ? roundPercentage((preparedQuantity / totalQuantity) * 100) : 0;
  const servedPercentage = totalQuantity > 0 ? roundPercentage((servedQuantity / totalQuantity) * 100) : 0;

  let orderFilterState = "pending";
  if (order?.status === "partially_served") {
    orderFilterState = "partially_served";
  } else if (servedQuantity >= totalQuantity && totalQuantity > 0) {
    orderFilterState = "served";
  } else if (preparationPercentage >= 100) {
    orderFilterState = "prepared";
  } else if (preparationPercentage > 0) {
    orderFilterState = "in_preparation";
  }

  let derivedStatusText = "Pendiente";
  let derivedStatusTone = "bg-slate-100 text-slate-700";

  if (orderFilterState === "partially_served") {
    derivedStatusText = "Servido parcialmente";
    derivedStatusTone = "bg-blue-100 text-blue-700";
  } else if (servedQuantity >= totalQuantity && totalQuantity > 0) {
    derivedStatusText = "Servido";
    derivedStatusTone = "bg-green-100 text-green-700";
  } else if (preparedQuantity >= totalQuantity && totalQuantity > 0) {
    derivedStatusText = "Preparado";
    derivedStatusTone = "bg-amber-100 text-amber-700";
  } else if (preparedQuantity > 0) {
    derivedStatusText = "En preparación";
    derivedStatusTone = "bg-orange-100 text-orange-700";
  }

  return {
    totalQuantity,
    pendingQuantity,
    preparedQuantity,
    servedQuantity,
    servableQuantity,
    servablePercentage,
    preparationPercentage,
    servedPercentage,
    orderFilterState,
    derivedStatusText,
    derivedStatusTone,
  };
};

export const matchesOrderStateFilter = (order, filterValue) => {
  if (!filterValue || filterValue === "all") return true;
  const metrics = getOrderPickingMetrics(order);
  return metrics.orderFilterState === filterValue;
};
